/**
 * Returns a string with the given list items in the following formats:
 *
 * Single item:
 *  - Item
 * Two items:
 *  - Item 1 & Item 2
 * 3+ items:
 *  - Item 1, Item 2, & Item 3
 *
 *  // GREP - so this helper is easier to find if it is needed down the line
 *  getComma
 *  getList
 *  getSeparated
 *  oxfordComma
 *  commaSeparated
 *  commaList
 *
 * @param items
 * @returns {string}
 */
export const getCommaSeparatedList = (items: string[]): string => {
    const [firstItem, ...restItems] = items;

    return [
        firstItem,
        ...restItems.map((item: string, index) =>
            index === restItems.length - 1 ? `& ${item}` : item
        ),
    ].join(items.length === 2 ? ' ' : ', ');
};
